/**
 * Created by jacky on 3/16/16.
 * @flow
 * @providesModule Constants
 */

const _ = {
    trINIT_ROW: 1e6,
    trROW_INC: 100,
    trINIT_COL: 1e6,
    trCOL_INC: 100,
    trROW_HEIGHT: 10,
    trCOL_WIDTH: 10,
    trTaskWidth: 252,
    trTaskHeight: 59,
    gcTransitionEnd: 'transitionend webkitTransitionEnd oTransitionEnd',
    gcSTAKey: 'STA',
    gcTutorialPopupKey: 'tutotial-popup-shown',
    gcTutorialWorkflowPopupKey: 'tutotial-workflow-popup-shown',
};

export default _;



// WEBPACK FOOTER //
// ./src/constants.js